module.exports = __webpack_public_path__ + "static/img/政策汇编@4x.13eb6b5f.png";